<p-dialog header="Bulk Actions"
          [(visible)]="showModal"
          (onHide)="closeModal()"
          [modal]="true"
          [resizable]="false"
          [contentStyle]="{ overflow: 'visible' }"
          [style]="{ width: '45rem' }">

    <div class="pb-3">
        <strong>{{ displayCount }}</strong> {{ displayCount === 1 ? 'site' : 'sites' }} selected
    </div>

    <div *ngIf="excludedCount > 0" class="mb-3">
        <lib-alert-banner
            alertType="tier2"
            [hidden]="false"
            maxWidth="100%"
            [message]="excludedCountMessage">
        </lib-alert-banner>
    </div>

    <div *ngIf="isAllSelected" class="mb-3">
        <lib-alert-banner
            alertType="tier2"
            [hidden]="false"
            maxWidth="100%"
            [message]="allPagesSelectedMessage">
        </lib-alert-banner>
    </div>

    <!-- Set Preconfigure Date -->
    <div class="mb-3">
        <label class="fw-semibold mb-2" for="preconfigureDate">Set Preconfigure Date</label>
        <lib-mm-datepicker id="preconfigureDate"
                           [(ngModel)]="preconfigureDate"
                           [minDate]="minSelectableDate"
                           [disabled]="!canSetPreconfigureDate"
                           [isInvalid]="!!getFieldError('scheduledPreconfigDate')">
        </lib-mm-datepicker>
        <div *ngIf="getFieldError('scheduledPreconfigDate')" class="text-danger small mt-1">
            {{ getFieldError('scheduledPreconfigDate') }}
        </div>
    </div>
    <!-- Set Enablement Date -->
    <div class="mb-3">
        <label class="fw-semibold mb-2" for="enablementDate">Set Enablement Date</label>
        <lib-mm-datepicker id="enablementDate"
                           [(ngModel)]="enablementDate"
                           [minDate]="minEnablementDate"
                           [disabled]="!canSetEnablementDate"
                           [isInvalid]="!!enablementDateError || !!getFieldError('scheduledEnableDate')">
        </lib-mm-datepicker>
        <div *ngIf="enablementDateError" class="text-danger small mt-1">
            {{ enablementDateError }}
        </div>
        <div *ngIf="getFieldError('scheduledEnableDate')" class="text-danger small mt-1">
            {{ getFieldError('scheduledEnableDate') }}
        </div>
    </div>

    <!-- General validation errors -->
    <div *ngIf="validationErrors.length > 0" class="mb-3">
        <ng-container *ngFor="let error of validationErrors">
            <div *ngIf="!error.field" class="alert alert-danger py-2 small">
                {{ error.message }}
            </div>
        </ng-container>
    </div>

    <hr>
    <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-outline-primary"
                data-identifier="preconfigure-migration-cancel"
                (click)="closeModal()">
            Cancel
        </button>
        <button class="btn btn-primary"
                data-identifier="preconfigure-migration-save"
                [disabled]="!canSave"
                (click)="save()">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"><output class="visually-hidden">Loading...</output></span>
            Save
        </button>
    </div>
</p-dialog>
